import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Plug, Database, FlaskConical, Scan, Laptop, Server } from "lucide-react";

const fade = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] } }),
};

const integrations = [
  { icon: Plug, name: "ABDM / ABHA" },
  { icon: Laptop, name: "HealthPlix" },
  { icon: FlaskConical, name: "Diagnostic Labs" },
  { icon: Scan, name: "Imaging Centers" },
  { icon: Database, name: "Hospital MIS" },
  { icon: Server, name: "Pharmacy APIs" },
];

export const IntegrationsSection = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section className="py-16 lg:py-20 section-bold" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: text */}
          <motion.div variants={fade} initial="hidden" animate={inView ? "visible" : "hidden"}>
            <div className="inline-block px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/10 mb-4">
              <span className="text-spaced !text-[10px]">I N T E G R A T I O N S</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-white mb-4">
              ABDM & EHR Integrations
            </h2>
            <p className="text-base text-white/60 max-w-md">
              We deeply integrate with your existing systems so your staff never has to learn another platform.
            </p>
          </motion.div>

          {/* Right: floating logos */}
          <motion.div variants={fade} initial="hidden" animate={inView ? "visible" : "hidden"} custom={1}>
            <div className="grid grid-cols-3 gap-4">
              {integrations.map((int, i) => (
                <motion.div
                  key={int.name}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={inView ? { opacity: 1, scale: 1 } : {}}
                  transition={{ delay: i * 0.1 + 0.3, duration: 0.4 }}
                  whileHover={{ y: -4, scale: 1.05 }}
                  className="glass-card-dark rounded-2xl p-5 text-center hover:bg-white/15 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center mx-auto mb-3">
                    <int.icon className="w-5 h-5 text-primary" />
                  </div>
                  <p className="text-xs font-semibold text-white">{int.name}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
